<div ng-style="{'width': calc(), 'height': '100%', 'background-color': barColor, 'border-radius': borderRadius}"></div>